import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ApiService } from 'src/app/shared/services/api.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';

@Component({
  selector: 'app-wbs-project-list',
  templateUrl: './wbs-project-list.component.html',
  styleUrls: ['./wbs-project-list.component.css']
})
export class WbsProjectListComponent implements OnInit, AfterViewInit {
  displayedColumns = ['srNo', 'projectName', 'projectIdentifier', 'stage', 'startDate', 'endDate', 'actions'];
  dataSource = new MatTableDataSource<any>([]);
  searchKeyword = '';
  loading = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private apiService: ApiService,
    private toastrMsgService: ToastrMsgService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.fetchProjects();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.dataSource.filter = filterValue;
  }

  fetchProjects(): void {
    this.loading = true;
    const params = { keyword: this.searchKeyword || '' };
    this.apiService.getProject(params).subscribe({
      next: (res: any) => {
        this.dataSource.data = Array.isArray(res) ? res : (res?.data || res?.projects || []);
      },
      error: (err) => {
        this.toastrMsgService.error(err?.error?.errorMessage || 'Failed to load projects');
        this.dataSource.data = [];
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openWBS(project: any): void {
    const projectId = project.id ?? project.project_id;
    if (projectId) {
      this.router.navigate(['/home/work-breakdown-structure', projectId]);
    } else {
      this.toastrMsgService.error('Invalid project');
    }
  }
}
